let pageBannerSlider = $('.page-banner--slider');
let pageBannerText = $('.page-banner--text-centered');
let pageBannerAuthor = $('.page-banner--author');

if (pageBannerSlider.length > 0) {
    let i;

    for (x = 0; x < $('.breadcrumbs .breadcrumbs__title a').length; x++) {
        $('.breadcrumbs a')[x].setAttribute("style", "color: white;");
    }

    for (i = 0; i < $('.breadcrumbs .breadcrumbs__title p').length; i++) {
        $('.breadcrumbs p')[i].setAttribute("style", "color: white;");
    }
}

if (pageBannerText.length > 0) {
    let i;

    for (x = 0; x < $('.breadcrumbs .breadcrumbs__title a').length; x++) {
        $('.breadcrumbs a')[x].setAttribute("style", "color: white;");
    }

    for (i = 0; i < $('.breadcrumbs .breadcrumbs__title p').length; i++) {
        $('.breadcrumbs p')[i].setAttribute("style", "color: white;");
    }
}

if (pageBannerAuthor.length > 0) {
    let i;

    // $('.breadcrumbs .breadcrumbs__title a')[0].setAttribute("style", "color: white;");

    for (x = 0; x < $('.breadcrumbs .breadcrumbs__title a').length; x++) {
        $('.breadcrumbs a')[x].setAttribute("style", "color: white;");
    }

    for (i = 0; i < $('.breadcrumbs .breadcrumbs__title p').length; i++) {
        $('.breadcrumbs p')[i].setAttribute("style", "color: white;");
    }
}